import type { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import type { AppError, AppErrorWithNotification } from 'src/app/core/app-error/app-error.interface';

export enum AppErrorActionType {
  AppErrorMajor = '[AppError] Major - Route to AppError page',
  AppErrorMinor = '[AppError] Minor - Display AppError notification',
  AppErrorMinorLoading = '[AppError] Minor - Loading data error'
}

export const appErrorMajor = createAction(AppErrorActionType.AppErrorMajor, props<{ error: AppError }>());

export const appErrorMinor = createAction(
  AppErrorActionType.AppErrorMinor,
  props<{ errorWithNotification: AppErrorWithNotification }>()
);

export const appErrorMinorLoading = createAction(
  AppErrorActionType.AppErrorMinorLoading,
  props<{ error: HttpErrorResponse }>()
);
